import xs from "xstream/index";
import { NEW_BASE_URL } from "../config";
import * as ActionTypes from "../actions/types";
import * as actions from "../actions";
import sampleCombine from "xstream/extra/sampleCombine";
import { generalHeader } from "./headers";
import {
  createBackendRequest,
  getUserIdFromState,
} from "../mappers/backendMappers";

const REQUEST_SEND_CONTACT_MAIL = "requestSendContactMail";
const REQUEST_CSRF_TOKEN = "requestCsrfToken";

export * from "../authentication/cycles/index";

export function requestSendContactMail(sources) {
  const state$ = sources.STATE;
  const userId$ = state$.map((state) => getUserIdFromState(state));
  const applicationUser$ = state$.map((state) => state.applicationUser);

  // Store the action payload to use after token is fetched
  const contactAction$ = sources.ACTION.filter(
    (action) => action.type === ActionTypes.SEND_CONTACT_FORM
  ).remember();

  // First, fetch CSRF token when contact form is submitted
  const csrfTokenRequest$ = contactAction$.map(() => ({
    url: NEW_BASE_URL + "/csrftoken/token",
    category: REQUEST_CSRF_TOKEN,
    method: "GET",
    headers: generalHeader(null, true),
    withCredentials: true, // Enable to receive and send cookies
  }));

  // Handle CSRF token response and then send contact form
  const csrfTokenResponse$ = sources.HTTP.select(REQUEST_CSRF_TOKEN)
    .map((response) => response.replaceError((err) => xs.of(err)))
    .flatten()
    .filter((response) => {
      console.log("CSRF Token response status:", response.status);
      return response.status === 200;
    });

  // Combine the token response with the original action and send the contact request
  const contactRequest$ = csrfTokenResponse$
    .compose(sampleCombine(contactAction$, userId$, applicationUser$))
    .map(([tokenResponse, action, userId, applicationUser]) => {
      // Extract CSRF token from response
      const csrfToken = tokenResponse.body?.token || tokenResponse.body || "";

      console.log("CSRF Token successfully received:", csrfToken);
      console.log("Now sending contact form with payload:", action.payload);
      console.log("Application user state:", applicationUser);

      // Create request body for new backend API
      // The API expects the contact data directly in the Payload
      const requestBody = createBackendRequest(
        {
          Name: action.payload.name || "",
          Mail: action.payload.mail || "",
          Subject: action.payload.subject || "",
          Message: action.payload.message || "",
        },
        userId
      );

      // Log the request body being sent
      console.log(
        "Request body being sent:",
        JSON.stringify(requestBody, null, 2)
      );
      console.log("Using CSRF token:", csrfToken);

      // Build headers with proper authentication
      const headers = {
        ...generalHeader(csrfToken, true), // Pass CSRF token to generalHeader
        "Content-Type": "application/json",
      };

      // Add additional authentication headers if available
      if (applicationUser?.accessToken) {
        headers["Authorization"] = `Bearer ${applicationUser.accessToken}`;
        console.log("Adding Bearer token to headers");
      }

      return {
        url: NEW_BASE_URL + "/contact/create",
        category: REQUEST_SEND_CONTACT_MAIL,
        method: "POST",
        headers: headers,
        send: requestBody,
        withCredentials: true, // Enable to send cookies including XSRF-TOKEN cookie
      };
    });

  const httpResponse$ = sources.HTTP.select(REQUEST_SEND_CONTACT_MAIL)
    .map((response) => response.replaceError((err) => xs.of(err)))
    .flatten()
    .map((response) => {
      console.log("Contact API Response status:", response.status);
      console.log("Contact API Response body:", response.body);
      console.log("Contact API Response headers:", response.headers);

      // Handle successful response (200 or 201)
      if (response.status === 200 || response.status === 201) {
        // Extract the contact ID from the response
        const contactId = response.body?.payload?.data?.id || response.body?.id;
        return actions.sendContactFormMessageSuccess({
          message: "Your message has been sent successfully!",
          contactId: contactId,
          success: true,
          resetForm: true,
        });
      } else {
        // Handle error response - get error message from response if available
        let errorMessage = "Failed to send message. Please try again.";

        if (response.status === 403) {
          errorMessage = "Authentication failed. Please log in and try again.";
          console.error("403 Forbidden - Authentication issue detected");
        } else if (response.body?.error?.message) {
          errorMessage = response.body.error.message;
        } else if (response.body?.message) {
          errorMessage = response.body.message;
        }

        console.error(
          "Contact form error:",
          errorMessage,
          "Status:",
          response.status,
          "Response:",
          response
        );
        return actions.sendContactFormMessageFailed({
          message: errorMessage,
          error: response,
        });
      }
    });

  return {
    ACTION: httpResponse$,
    HTTP: xs.merge(csrfTokenRequest$, contactRequest$),
  };
}
